import React from 'react';
import Sparkle from './Sparkle';

const cx = (...c) => c.filter(Boolean).join(' ');

const TONE = {
  quiet: 'bg-white text-muted border-y border-line',
  cream: 'bg-cream text-muted border-y border-line',
  ink: 'bg-ink text-white/70',
};
const SPARK = { quiet: '#c0c0c0', cream: '#95a8e6', ink: '#ffb442' };

/** Subtle scrolling ticker of phrases separated by small sparkles. */
const Marquee = ({ items, tone = 'quiet', className }) => {
  const row = (
    <div className="flex items-center" aria-hidden="true">
      {items.map((item, i) => (
        <span className="inline-flex items-center gap-4 px-4 text-xs sm:text-sm font-semibold uppercase tracking-[0.1em]" key={i}>
          {item}
          <Sparkle size={11} color={SPARK[tone]} />
        </span>
      ))}
    </div>
  );
  return (
    <div className={cx('overflow-hidden whitespace-nowrap select-none py-3', TONE[tone], className)}>
      <div className="inline-flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row}
        {row}
      </div>
    </div>
  );
};

export default Marquee;
